export default __webpack_public_path__ + "static/media/vectordropdown.6b702e23.svg";